<template>
	<v-card-text v-if="hiddenData">
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">lock</v-icon>
			<v-toolbar-title>Dane dodatkowe (ukryte dla wolontariusza)</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-alert
						:value="data.accountRemovalRequested"
						type="error"
						outline
					>Wolontariusz zgłosił prośbę o usunięcie konta!
					</v-alert>
				</v-flex>
			</v-layout>
			<v-layout row class="mb-2">
				<v-flex xs2/>
				<v-flex xs7>
					<v-switch
						v-model="data.schoolingCompleted"
						:label="data.schoolingCompleted ? 'Ukończone szkolenie wolontariuszy' :
							'Nie ukończono szkolenia wolontariuszy'"
						aria-label="schooling completed"
						for="hidden-profile-data-view-schooling-completed"
						id="hidden-profile-data-view-schooling-completed"
						color="primary"
						hide-details
						:disabled="readOnlyMode"
						class="mb-4"
					></v-switch>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						outline
						label="Żądania wolontariusza dot. realizacji praw związanych z jego danymi osobowymi"
						for="hidden-profile-data-view-notes"
						id="hidden-profile-data-view-notes"
						aria-label="notes"
						:readonly="readOnlyMode"
						v-model="data.notes"
					></v-textarea>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	export default {
		name: "HiddenProfileDataView",

		data () {
			return {
				readOnlyMode: true,

				data: {},
			};
		},

		watch: {
			hiddenData: function () {
				this.data = this.hiddenData;
			},

			readOnlyMode: function (value) {
				this.$emit("edition-status", !value);
			},
		},

		computed: {
			icon () {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel () {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		props: {
			hiddenData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

</style>